'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _systemIngredientForm = require('./system-ingredient-form.html');

var _systemIngredientForm2 = _interopRequireDefault(_systemIngredientForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _systemIngredientForm2.default,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    ingredient: '<',
    dialogTitle: '@',
    submitTitle: '@',
    ingredientChanged: '&'
  },
  controller: function () {
    function SystemIngredientFormComponent(EventEmitter) {
      'ngInject';

      _classCallCheck(this, SystemIngredientFormComponent);

      Object.assign(this, { EventEmitter: EventEmitter });
    }

    _createClass(SystemIngredientFormComponent, [{
      key: 'onSubmit',
      value: function onSubmit() {
        this.ingredientChanged(this.EventEmitter({
          ingredient: this.ingredient
        }));
      }
    }]);

    return SystemIngredientFormComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/admin/system-ingredients/system-ingredient-form/system-ingredient-form.component.js